var _g, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHealthNotes(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 1.5,
    stroke: "currentColor",
    fill: "none",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 5H5a1 1 0 00-1 1v15a1 1 0 001 1h14a1 1 0 001-1V6a1 1 0 00-1-1h-2M8 16h8M10 19h4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 4l.447-.894A2 2 0 0111.236 2h1.528a2 2 0 011.789 1.106L15 4h1a1 1 0 011 1v1a1 1 0 01-1 1H8a1 1 0 01-1-1V5a1 1 0 011-1h1zM10.5 11.5h3M12 10v3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })));
}

export default SvgHealthNotes;


//////////////////
// WEBPACK FOOTER
// ./src/icons/health-notes.svg
// module id = 864
// module chunks = 101